import axios from 'axios'
import HTTP from './http'

export default {
    getList: () => axios.get(HTTP.SYNONYMS_LIST),
    search: payload => axios.get(HTTP.SYNONYMS_SEARCH, { params: { ...payload } }),
    getTerms: payload => axios.get(HTTP.SYNONYMS_TERMS, { params: { ...payload } }),
    addSynonym: payload => axios.post(HTTP.SYNONYM, payload),
    updateSynonym: payload => axios.put(HTTP.SYNONYM, payload),
    deleteSynonym: payload => axios.delete(HTTP.SYNONYM, { params: { id: payload } })
}
